import { render } from "./EditRole.vue?vue&type=template&id=1b2cecbc"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__